export default __webpack_public_path__ + "79355cd2de5ad4b0358ad25e643e5ba9.png";